package com.starparty.app.astro0.celestialbodies

import com.starparty.app.astro0.Constellation
import com.starparty.app.astro0.SP_Colour
import com.starparty.app.astro0.SP_Time

/**
 * Title:        Starparty Astro-0
 * Description:  Simply astronomy package for starparty.com and sennen-cove-cornwall.uk
 * Copyright:    Copyright (c) 2021
 * Company: starparty.com
 * @author Rob Leeson
 * @version 2.0
 */
open class Star(
        t: SP_Time,
        ra: Double,
        dec: Double,
        var constellation: Int,
        var bayerDesignation: String,
        var flamsteadNumber: String,
        var visMag: Double,
        /** Returns B-V color in the UBV system  */
        var bV: Double,
        var spectralType: String,
        name: String

) : CelestialBody(ra, dec, name) {

    val DEF_STAR_COLOR: SP_Colour = SP_Colour(255,255,255,255) // WHITE
    val constellationName: String?
        get() {
            var name: String? = null
            name = if (constellation == Constellation.UNKNOWN_CONST) {
                "UNKNOWN"
            } else {
                Constellation.NAMES.get(constellation).get(Constellation.NAME)
            }
            return name
        }

    val constellationAbbr: String?
        get() {
            var name: String? = null
            name = if (constellation == Constellation.UNKNOWN_CONST) {
                "UNK"
            } else {
                Constellation.NAMES.get(constellation).get(Constellation.ABB)
            }
            return name
        }

    /** Overrides abstract method in superclass to do nothing.
     * Might in future be used to correct position for proper motion,
     * precession etc.  */
    override fun recalculateEquatorialCoordinates(time: SP_Time) {}

    init {
        recalculateEquatorialCoordinates(t)
        recalculateCartesianCoordinates(t)

        rgbColour = DEF_STAR_COLOR
        abbrevName = bayerDesignation
    }
}